import {Fragment, useEffect, useState} from "react";
import { imgOnConstruction } from "../img/ImgBarrel"
// import {Loading} from "./LoadingComponent";
import {Backdrop, CircularProgress} from "@mui/material";

export function PageWorkingComponent(){

    const [ statusLoad, setStatusLoad ] = useState(true);


    useEffect(() => {
        // Mostrar la alerta después de 5 segundos
        const timeoutId = setTimeout(() => {

            setStatusLoad(()=>false);
        }, 5000);


        // Limpia el temporizador cuando el componente se desmonta o cuando la alerta se muestra antes de los 5 segundos
        return () => clearTimeout(timeoutId);
    }, []);

    return(
        <Fragment>
            {
                statusLoad ?
                <Backdrop open={statusLoad} onClick={null}>
                    <CircularProgress/>
                </Backdrop>:
                <img width="100%" height="600vh" src={imgOnConstruction.default} alt="Pagina en construccion"/>
            }

        </Fragment>
    );
}